var _rect, _rect2, _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPtaBackground(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 238,
    height: 138,
    viewBox: "0 0 238 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 238,
    height: 138,
    fill: "#5db8f6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 238,
    height: 138,
    rx: 20,
    fill: "#5DB8F6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 190.5,
    cy: 40.5,
    r: 19.5,
    fill: "#FFDE32"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M237.542 122.277C235.583 131.268 227.578 138 218 138H202.75C200.392 134.776 199 130.801 199 126.5C199 115.73 207.73 107 218.5 107C227.82 107 235.612 113.538 237.542 122.277Z",
    fill: "#E5E5E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M120.536 138C119.541 135.185 119 132.156 119 129C119 114.088 131.088 102 146 102C160.912 102 173 114.088 173 129C173 132.156 172.459 135.185 171.464 138H163.865C165.231 135.295 166 132.237 166 129C166 117.954 157.046 109 146 109C134.954 109 126 117.954 126 129C126 132.237 126.769 135.295 128.135 138H120.536Z",
    fill: "#102689"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPtaBackground);
export default __webpack_public_path__ + "static/media/PTA_Background.f2933530893a963f72a38add0041de25.svg";
export { ForwardRef as ReactComponent };